// extracted by mini-css-extract-plugin
export default {"home__section":"Home_home__section__NTxvr"};